import { InjectionToken } from '@angular/core';
import { BaseApiService } from '@shared/services/apiService/base-api.service';
import { BaseApiDTO } from '@shared/dto/BaseApiDTO';


export interface CowsApiDTO extends BaseApiDTO {
  name?: string;
  tag?: string;
  breed?: string;
  gender?: string;
  color?: string;
  motherId?: string;
  fatherId?: string;
  birthDate?: Date;
  description?: string;
  weight?: number;
  height?: number;
  dietPlan?: string;
  fertilityStatus?: FertilityStatus;
  lastInseminationDate?: Date;
  lastCalvingDate?: Date;
  expectedCalvingDate?: Date;
  milkQuality?: string;
  milkYield?: number;
  lactationStartDate?: Date;
  fieldId?: string;
}

export const cows_token = new InjectionToken<BaseApiService<CowsApiDTO>>('api token');

export enum FertilityStatus {
  NONE = 'NONE',
  OPEN = 'OPEN',
  IN_HEAT = 'IN_HEAT',
  BRED = 'BRED',
  PREGNANT = 'PREGNANT',
  DRY = 'DRY',
  CALVING = 'CALVING',
  POSTPARTUM = 'POSTPARTUM',
  ANESTRUS = 'ANESTRUS',
  INFERTILE = 'INFERTILE',
  CULLED = 'CULLED',
}
